export default "__VITE_ASSET__zAc28ap___"